<template>
  <v-container fluid>
    <v-row class="d-flex">
      <v-col cols="12" sm="12" md="6" lg="8" class="d-flex">
        <Scale />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="4" class="d-flex">
        <Birthdays />
      </v-col>
    </v-row>
    <div class="row">
      <v-col cols="12" sm="12" md="6" lg="6">
        <PayChecks />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <IncomeTaxList />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import PayChecks from './components/PayChecks'
import Birthdays from './components/Birthdays'
import Scale from '../scales/components/Scale.vue'
import IncomeTaxList from '../IncomeTax/componnents/IncomeTaxList'
export default {
  name: 'Home',
  components: {
    PayChecks,
    Birthdays,
    Scale,
    IncomeTaxList,
  },
}
</script>
